import React, { useState } from 'react';

const Header = ({ currentView, setCurrentView, user, onLogout }) => {
    const [showUserMenu, setShowUserMenu] = useState(false);

    const navItems = [
        { key: 'dashboard', label: 'Dashboard' },
        { key: 'members', label: 'Members' },
        { key: 'contributions', label: 'My Contributions' },
        { key: 'death-reports', label: 'Death Reports' },
        { key: 'vouchers', label: 'My Vouchers' },
        { key: 'profile', label: 'Profile' },
    ];

    const handleLogout = () => {
        onLogout();
        setShowUserMenu(false);
    };

    return (
        <header className="bg-white shadow-sm border-b">
            <div className="container mx-auto px-4">
                <div className="flex justify-between items-center py-4">
                    <div className="flex items-center space-x-4">
                        <h1 className="text-2xl font-bold text-primary-600">Chema</h1>
                        <p className="text-gray-600">Mutual Support in Times of Need</p>
                    </div>

                    <div className="flex items-center space-x-4">
                        <div className="text-right">
                            <p className="font-semibold">{user.name}</p>
                            <p className="text-sm text-gray-600">Balance: ${user.availableBalance}</p>
                        </div>

                        {/* User Menu */}
                        <div className="relative">
                            <button
                                onClick={() => setShowUserMenu(!showUserMenu)}
                                className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center text-white font-semibold hover:bg-primary-600 transition-colors"
                            >
                                {user.name.charAt(0)}
                            </button>

                            {showUserMenu && (
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                                    <div className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
                                        Signed in as<br />
                                        <strong>{user.email}</strong>
                                    </div>
                                    <button
                                        onClick={() => {
                                            setCurrentView('profile');
                                            setShowUserMenu(false);
                                        }}
                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        👤 Your Profile
                                    </button>
                                    <button
                                        onClick={handleLogout}
                                        className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 transition-colors"
                                    >
                                        🚪 Sign out
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <nav className="flex space-x-8">
                    {navItems.map((item) => (
                        <button
                            key={item.key}
                            onClick={() => setCurrentView(item.key)}
                            className={`py-3 px-1 border-b-2 font-medium text-sm ${
                                currentView === item.key
                                    ? 'border-primary-500 text-primary-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            {item.label}
                        </button>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Header;